export const isSuperAdmin = ( permissions ) => Array.isArray(permissions) && permissions.includes("ROLE_SUPER_ADMIN");
